/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the OrganizationApiConfiguration configuration object with a given root URL.
 */
export function provideOrganizationApiConfiguration(rootUrl: string) {
  var config = new OrganizationApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: OrganizationApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class OrganizationApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `OrganizationModule.forRoot()`
 */
export interface OrganizationApiConfigurationParams {
  rootUrl?: string;
}
